<template>
  <div class="newhomebanner">
    <el-carousel
      class="NewHomeBanner_cont_img"
      :interval="5000"
      trigger="click"
      :height="bannerH +'px'"
      arrow="always"
    >
      <el-carousel-item v-for="item of list" :key="item.id">
        <img :src="item" class="bannerImg" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>



<script>
import { gethomepc } from "@/config/api.js";
export default {
  name: "HomeBanner",
  data() {
    return {
      bannerH: 200,
      list: Array
    };
  },
  methods: {
    setBannerH() {
      this.bannerH = document.body.clientWidth / 3.2;
    },
    getbanner() {
      this.$post(gethomepc, { key: "web_banner" }).then(res => {
        this.list = res.data;
      });
    }
  },
  mounted() {
    this.getbanner();
    this.setBannerH();
    window.addEventListener(
      "resize",
      () => {
        this.setBannerH();
      },
      false
    );
  }
};
</script>
<style>
.newhomebanner .el-carousel__button {
  width: 8px;
  height: 8px;
  background: rgba(224, 224, 224, 1);
  opacity: 1;
  border-radius: 4px;
}
.newhomebanner .el-carousel__indicator.is-active button {
  width: 16px;
  height: 8px;
  background: rgba(255, 117, 31, 1);
  opacity: 1;
  border-radius: 4px;
}
.bannerImg {
  width: 100%;
  height: auto;
}
.newhomebanner .el-icon-arrow-left {
  font-size: 24px;
  color: #d8d8d8;
}
.newhomebanner  .el-icon-arrow-right {
  font-size: 24px;
  color: #d8d8d8;
}
.newhomebanner .el-carousel__arrow{
    width: 40px;
    height: 100px;
    border-radius:4px;
    background: none;
}
.newhomebanner .el-carousel__arrow:hover{
    background-color: rgba(31,45,61,.11); 

    /* opacity:0.3; */
}
.newhomebanner .el-carousel__arrow:hover i{
    color: #7A7A7A;
    opacity:1;
}
.newhomebanner .el-carousel__arrow--left{
    left: 280px;
}
.newhomebanner .el-carousel__arrow--right{
    right: 280px;
}
</style>
